import { MessageType } from "../gateways/MessageGateway";

export const CountryCodes = [
  { name: "Albania", code: "+355" },
  { name: "Andorra", code: "+376" },
  { name: "Argentina", code: "+54" },
  { name: "Australia", code: "+61" },
  { name: "Austria", code: "+43" },
  { name: "Belarus", code: "+375" },
  { name: "Belgium", code: "+32" },
  { name: "Bosnia and Herzegovina", code: "+387" },
  { name: "Brazil", code: "+55" },
  { name: "Bulgaria", code: "+359" },
  { name: "Canada", code: "+1" },
  { name: "China", code: "+86" },
  { name: "Croatia", code: "+385" },
  { name: "Cyprus", code: "+357" },
  { name: "Czech Republic", code: "+420" },
  { name: "Denmark", code: "+45" },
  { name: "Estonia", code: "+372" },
  { name: "Finland", code: "+358" },
  { name: "France", code: "+33" },
  { name: "Germany", code: "+49" },
  { name: "Greece", code: "+30" },
  { name: "Hungary", code: "+36" },
  { name: "Iceland", code: "+354" },
  { name: "India", code: "+91" },
  { name: "Ireland", code: "+353" },
  { name: "Italy", code: "+39" },
  { name: "Japan", code: "+81" },
  { name: "Latvia", code: "+371" },
  { name: "Liechtenstein", code: "+423" },
  { name: "Lithuania", code: "+370" },
  { name: "Luxembourg", code: "+352" },
  { name: "Malta", code: "+356" },
  { name: "Mexico", code: "+52" },
  { name: "Moldova", code: "+373" },
  { name: "Monaco", code: "+377" },
  { name: "Montenegro", code: "+382" },
  { name: "Netherlands", code: "+31" },
  { name: "North Macedonia", code: "+389" },
  { name: "Norway", code: "+47" },
  { name: "Poland", code: "+48" },
  { name: "Portugal", code: "+351" },
  { name: "Romania", code: "+40" },
  { name: "Russia", code: "+7" },
  { name: "San Marino", code: "+378" },
  { name: "Serbia", code: "+381" },
  { name: "Slovakia", code: "+421" },
  { name: "Slovenia", code: "+386" },
  { name: "South Africa", code: "+27" },
  { name: "Spain", code: "+34" },
  { name: "Sweden", code: "+46" },
  { name: "Switzerland", code: "+41" },
  { name: "Ukraine", code: "+380" },
  { name: "United Kingdom", code: "+44" },
  { name: "United States", code: "+1" },
  { name: "Vatican City", code: "+379" }
];

export interface UserDetails{
    firstName : string,
    lastName : string,
    phoneCode: string,
    phoneNumber: string | null,
    messagePreference: MessageType,
    messagePreferenceVerified: boolean
}